import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Row, Col, InputGroup, Table } from "react-bootstrap";
import { FiRefreshCcw } from 'react-icons/fi';
import * as XLSX from "xlsx";
import { notify } from '../components/actions/CommonActions';
import { allBatchApi, batchUploadFile, batchUploadFileRecreate, sendNotificationApi, updateBatchApi } from '../services';
import LoadingModal from '../components/modals/LoadingModal';
import moment from 'moment/moment';
import { HiOutlineDotsVertical } from "react-icons/hi";
import { ModalSendNotification } from '../components/modals/ModalSendNotification';
import { ModalUpdateBatch } from '../components/modals/ModalUpdateBatch';
import { useNavigate } from 'react-router';

const UploadFile = () => {
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [batchFile, setBatchFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null)
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);
  const [sendNotifyModal, setSendNotifyModal] = useState(false)
  const [updateBatchModal, setUpdateBatchModal] = useState(false)
  const [loadingSendNotify, setLoadingSendNotify] = useState(false)
  const [loadingUpdateBatch, setLoadingUpdateBatch] = useState(false)
  const [batchId, setBatchId] = useState(null)
  const [gottenBatch, setGottenBatch] = useState([])
  const navigate = useNavigate()
  
  const handleAllBatch = async () =>{
    setIsLoading(true)
      await allBatchApi()
            .then((res) => {
              // console.log("res all ", res?.data);
              setGottenBatch(res?.data)
              setIsLoading(false)
            })
            .catch((error) => {
              setIsLoading(false);
              notify("danger", "OOPS", error.response.data.response);
            });
      setIsLoading(false)
  }

  const handleSendNotification = async(payload) =>{
    setLoadingSendNotify(true)
    await sendNotificationApi(payload?.date, batchId, payload?.target)
            .then((res) => {
              notify("success", "Success", res?.message);
              setLoadingSendNotify(false)
              setSendNotifyModal(false)
            })
            .catch((error) => {
              setLoadingSendNotify(false);
              notify("danger", "OOPS", error.response.data.response);
            });
    setLoadingSendNotify(false)
  }

  const handleUpdateBatch = async(payload) =>{
    setLoadingUpdateBatch(true)
    await updateBatchApi(payload)
            .then(async (res) => {
              notify("success", "Success", res?.message);
              setLoadingUpdateBatch(false)
              setUpdateBatchModal(false)
              await handleAllBatch()
            })
            .catch((error) => {
              setLoadingUpdateBatch(false);
              notify("danger", "OOPS", error.response.data.response);
            });
            setLoadingUpdateBatch(false)
  }


  const toggleDropdown = (id) => {
    setOpenDropdownId(id);
    setBatchId(id)
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUploadFile = async () => {
    setIsUploadFile(true);
    const formData = new FormData()
    formData.append('file', uploadedFile)
    console.log("uploaded file: ", uploadedFile);
    await batchUploadFileRecreate(formData)
      .then((res) => {
          // const storedPage = sessionStorage.getItem("currentPage");
          // const initialPage = storedPage ? parseInt(storedPage, 10) : 1;
          notify("success", "success", res?.message);
          setIsUploadFile(false);

      })
      .catch((error) => {
        console.log("err data");
        
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsUploadFile(false);
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file)
    //   if (file) {
    //     const reader = new FileReader();

    //     reader.onload = (e) => {
    //       const data = e.target.result;
    //       const workbook = XLSX.read(data, { type: "binary" });
    //       const sheetName = workbook.SheetNames[0];
    //       const worksheet = workbook.Sheets[sheetName];

    //       // Define the expected headers
    //       const expectedHeaders = [
    //         "startDate",
    //         "endDate",
    //         "accountNumber",
    //         "payerAddress",
    //         "frequency",
    //         "email",
    //         "narration",
    //         "bank",
    //         "mandateBankCode",
    //         "payer",
    //         "accountName",
    //         "amount",
    //         "phoneNumber",
    //         "subscriberCode",
    //         "productId",
    //         "mandateType",
    //         "dryRun"
    //       ]; // Replace with your expected headers

    //       // Get the headers from the first row of the Excel file
    //       const headersInFile = XLSX.utils.sheet_to_json(worksheet, {
    //         header: 1,
    //       })[0];

    //       // Check if the headers in the file match the expected headers
    //       const isValidFile = expectedHeaders.every((header) =>
    //         headersInFile.includes(header)
    //       );

    //       if (!isValidFile) {
    //         notify(
    //           "danger",
    //           "Invalid file",
    //           "Invalid file structure. Please upload a file with the correct headers."
    //         );
    //         return;
    //       }

    //       // const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    //       // Assuming the first row contains headers/names for the properties
    //       const headers = headersInFile;

    //       // Create an array of objects using headers as property names
    //       // const dataArray = excelData.slice(1).map((row) => {
    //       //   const obj = {};
    //       //   headers.forEach((header, index) => {
    //       //     obj[header] = row[index];
    //       //   });
    //       //   return obj;
    //       // });

    //       const dataArray = XLSX.utils
    //         .sheet_to_json(worksheet, { header: 1 })
    //         .slice(1)
    //         .map((row) => {
    //           const obj = {};
    //           row.forEach((cell, index) => {
    //             // Check if the cell is a date and convert it to JS Date
    //             if (headers[index] && worksheet[`${headers[index]}_t`] === "n") {
    //               const dateCode = cell;
    //               const jsDate = XLSX.SSF.parse_date_code(dateCode);
    //               obj[headers[index]] = jsDate;
    //             } else {
    //               obj[headers[index]] = cell;
    //             }
    //           });
    //           return obj;
    //         });

    //       setBatchFile(dataArray);
    //       dataArray?.length > 0 ? setIsUploaded(true) : setIsUploaded(false);
    //     };

    //     reader.readAsBinaryString(file);
    //   }
  };



  useEffect(()=>{
    const initiate = async () =>{
      await handleAllBatch()
    }
    initiate()
  },[])


  return (
    <>
    {isLoading ? (
        <div className="typewriter-container">
          <div class="typewriter">
            <div class="slide">
              <i></i>
            </div>
            <div class="paper"></div>
            <div class="keyboard"></div>
          </div>
          <code style={{ color: "#000" }}>Getting your app ready...</code>
        </div>
      ) : (
    <div>
      <Row className="mb-3">
        <Form.Group as={Col} controlId="formGridCity">
          <Form.Label>Upload File</Form.Label>
          <InputGroup>
            <Form.Control
              type="file"
              placeholder="Upload excel file."
              name="excelFile"
              onChange={handleFileChange}
            />
            <Button
              variant="outline-secondary"
              onClick={(e) => {
                e.preventDefault();
                handleUploadFile();
              }}
              disabled={isUploadFile}
            >
              {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload"}
            </Button>
          </InputGroup>
        </Form.Group>
      </Row>

      {/* <div class="table-wrapper"> */}
        <table className="fl-table">
          <thead>
            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
              {/* Table header cells */}
              {/* Modify according to your data structure */}
              <th width="20%">Session Id</th>
              <th>Status</th>
              <th>Total Records</th>
              <th>Created At</th>
              <th>...</th>
            </tr>
          </thead>
          <tbody>
            {
              gottenBatch?.map((mandate) => (
                <tr
                  className="tr"
                  key={mandate.id}
                >
                  <td className="gray-td">{mandate?.sessionId}</td>
                  <td className="gray-td">{mandate?.status}</td>
                  <td className="gray-td">{mandate?.totalRecords}</td>
                  <td className="gray-td">
                    {moment(mandate?.createdAt).format('YYYY-MM-DD')}
                  </td>
                  <td style={{ textAlign: "center" }} >
                    <div className="relative" style={{ position: "relative" }}>
                      {/* Dropdown Toggle Button */}
                      <button
                        onClick={() => toggleDropdown(mandate?.sessionId)}
                        className="dotsBtn"
                      >
                        <HiOutlineDotsVertical />
                      </button>

                      {/* Dropdown Menu - Show only for the selected row */}
                      {openDropdownId === mandate?.sessionId && (
                        <div className="dropdownSelect" ref={dropdownRef} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)', }}>
                          <div className="updateBtn">
                            <button
                              onClick={() => {
                                navigate(`/workflow-report/${mandate?.sessionId}`)
                              }}
                              style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                            >
                              View Summary
                            </button>
                          </div>
                          {/* <div className="updateBtn">
                            <button
                              onClick={() => {
                                navigate(`/all-mandates/${mandate?.sessionId}`)
                              }}
                              style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                            >
                              View Mandates
                            </button>
                          </div> */}
                          <div className="updateBtn">
                            <button
                              onClick={() => {
                                setBatchId(mandate?.id)
                                setUpdateBatchModal(true)
                              }}
                              style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                            >
                              Update batch
                            </button>
                          </div>
                          <div className="updateBtn">
                            <button
                              onClick={() => {
                                setSendNotifyModal(true)
                              }}
                              style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                            >
                              Send notifications
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      {/* </div> */}
      <LoadingModal show={isUploadFile} />
      <ModalSendNotification show={sendNotifyModal} toggle={()=> setSendNotifyModal(!sendNotifyModal)} handleResumeMandate={handleSendNotification} isResuming={loadingSendNotify} openDropdownId={batchId} />
      <ModalUpdateBatch show={updateBatchModal} toggle={()=> setUpdateBatchModal(!updateBatchModal)} handleResumeMandate={handleUpdateBatch} isResuming={loadingUpdateBatch} openDropdownId={batchId} />
    </div>
      )
    }
    </>
  )
}

export default UploadFile